<!--
  ~ QUEST SOFTWARE PROPRIETARY INFORMATION
  ~
  ~ This software is confidential.  Quest Software Inc., or one of its
  ~ subsidiaries, has supplied this software to you under terms of a
  ~ license agreement, nondisclosure agreement or both.
  ~
  ~ You may not copy, disclose, or use this software except in accordance with
  ~ those terms.
  ~
  ~
  ~ Copyright 2026 Quest Software Inc.
  ~ ALL RIGHTS RESERVED.
  ~
  ~ QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
  ~ WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
  ~ EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
  ~ TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
  ~ FITNESS FOR A PARTICULAR PURPOSE, OR
  ~ NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
  ~ LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
  ~ AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
  ~ THIS SOFTWARE OR ITS DERIVATIVES.
  -->

<div class="admin-container" [ngClass]="theme">
  <div class="top-header-row">
    <div class="left-side-section">
      <fac-breadcrumb-wrapper [addNewBreadcrumbItem]="breadcrumbItems"></fac-breadcrumb-wrapper>
    </div>
    <div  class="right-side-section">
        <a
          tabindex="0"
          class="monitor-link"
         (click)="openDocumentation()"
        >
        <mat-icon
          [svgIcon]="'fac-arrow-path'"
          class="mat-path-icon"
        ></mat-icon>
        <span> Documentation </span>
      </a>  
      <div class="advance-mode" *ngIf="isCloud === false">
        <div class="advance-mode-text">Advanced</div>
        <div class="advance-mode-switch"><fac-switcher [options]="advanceModeSwitchOptions" (onToggleChange)="onAdvanceModeSwitchToggleChanged($event)"></fac-switcher></div>
      </div>
    </div>
  </div>
  <div
    class="external-fglam"
    *ngIf="
      ((isCloudEnv$ | async) && isExternalfglamRequired && !isCloudUserGroup) ||
      (!(isCloudEnv$ | async) &&
        isExternalfglamRequired &&
        !isFoglightUserGroup)
    "
  >
    <label class="external-fglam-label">
      To start monitoring, download the Foglight Agent Manager and install it on
      your environment.
    </label>
    <button
      agent-button
      [type]="'button'"
      (click)="menu.toggle($event)"
      (keyup.enter)="menu.toggle($event)"
      (keydown.Tab)="menu.hide()"
    >
      <label class="agent-btn-label">
        Download
        <fc-svg-icon
          *ngIf="!arrowState"
          class="arrow-up"
          svgName="arrow-up"
        ></fc-svg-icon>
        <fc-svg-icon
          *ngIf="arrowState"
          class="arrow-down"
          svgName="arrow-down"
        ></fc-svg-icon>
      </label>
      <fac-dropdown
        #menu
        [popup]="'true'"
        [model]="items"
        (onSelectedItem)="onItemSelect($event, menu)"
        (keyup.enter)="onItemSelect($event, menu)"
        (onShow)="onDropdownShow()"
        (onHide)="onDropdownHide()"
        [selectedItem]="selectedItem"
      ></fac-dropdown>
    </button>
    <button
      *ngIf="isCloudEnv$ | async"
      agent-button
      [type]="'button'"
      (click)="goToVideo()"
    >
      <label class="agent-btn-label"> Watch Video </label>
    </button>
  </div>

  <div
    class="insufficient-roles"
    *ngIf="
      ((isCloudEnv$ | async) && isCloudUserGroup) ||
      (!(isCloudEnv$ | async) && isFoglightUserGroup)
    "
  >
    <mat-icon [svgIcon]="'fac-general-warning'" class="mat-alert-icon"></mat-icon>
    <span>
      <div class="alert-title">Insufficient Roles</div>
      <div class="alert-text">
        To effectively operate Foglight, you require additional roles to be
        assigned to your user account. Contact your Foglight<span
          *ngIf="isCloudEnv$ | async"
        >
          Cloud</span
        >
        Administrator to get additional roles assigned to your account.
      </div>
    </span>
  </div>

  <div class="welcome-page-content">
    <div *ngIf="isAdvanceModeSwitchChecked === false" class="left-content">
      <span class="left-title">Manage your agents</span>

      <div class="monitor-content">
        <div class="monitor">
          <!-- <button monitor-btn [type]="'button'"> -->
          <mat-icon
            [svgIcon]="'fac-we-agents'"
            class="mat-agent-icon"
          ></mat-icon>
          <!-- </button> -->
          <div class="monitor-title">Agents</div>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_agents_agenthost.agentHosts',
                'Agent Managers'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage agents</span>
          </a>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_agents_agent_status.agentStatus',
                'Agent Status'
              )
            "
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Check agent status</span>
          </a>
        </div>
        <div class="monitor">
          <!-- <button monitor-btn [type]="'button'"> -->
          <mat-icon
            [svgIcon]="'fac-we-credentials'"
            class="mat-agent-icon"
          ></mat-icon>
          <!-- </button> -->

          <div class="monitor-title">Credentials</div>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_credentials.Credentials',
                'Credentials'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Manage Credentials</span>
          </a>
        </div>
      </div>
      <div class="download-layout">
        <span class="left-secondary-text-label">Download agent manager: </span>
        <div class="monitor-link">
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="download-agent-styles"
            (click)="onItemSelect(items[0])"
          >
            <fc-svg-icon
              class="icon-styles"
              svgName="windows_icon"
            ></fc-svg-icon>

            <span class="left-secondary-text-label">For Windows</span>
          </a>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="download-agent-styles"
            (click)="onItemSelect(items[1])"
          >
            <fc-svg-icon class="icon-styles" svgName="linux_icon"></fc-svg-icon>
            <span class="left-secondary-text-label">For Linux</span>
          </a>
        </div>
      </div>

      <div class="monitor-content">
        <div class="monitor">
          <!-- <button monitor-btn [type]="'button'"> -->
          <mat-icon
            [svgIcon]="'fac-we-setup'"
            class="mat-agent-icon"
          ></mat-icon>
          <!-- </button> -->
          <div class="monitor-title">Setup</div>
          <a
            *ngIf="isCloudEnv$ | async"
            tabindex="0"
            [class.disabled]="isCloudUserGroup"
            class="monitor-link"
            (click)="redirectToAUI('/audit-log', 'Audit Log')"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Review Audit Log</span>
          </a>

          <a
            *ngIf="!(isCloudEnv$ | async)"
            tabindex="0"
            [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_cartridges_cartridgeinventory.cartridgeInventory',
                'Cartridge Inventory'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Cartridges</span>
          </a>

          <a
            *ngIf="!(isCloudEnv$ | async)"
            tabindex="0"
            [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport_managelicenses.manageLicensesLayout',
                'Manage Licenses'
              )
            "
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Licenses</span>
          </a>


          <a
          tabindex="0"
          [class.disabled]="!isFoglightAdministrator"
          class="monitor-link"
          (click)="manageAlarmsAILicense()"
          style="padding-top: 4px"
          >
          <mat-icon
            [svgIcon]="'fac-arrow-path'"
            class="mat-path-icon"
          ></mat-icon>
          <span>Manage Foglight AI License</span>
        </a>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_blackout_configuration.blackouts',
                'Blackouts'
              )
            "
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Manage Blackouts</span>
          </a>
        </div>

        <div class="monitor" *ngIf="!(isCloudEnv$ | async)">
          <!-- <button monitor-btn [type]="'button'"> -->
          <mat-icon
            [svgIcon]="'fac-we-diagnostic'"
            class="mat-agent-icon"
          ></mat-icon>
          <!-- </button> -->
          <div class="monitor-title">Diagnostic</div>

          <a
            tabindex="0"
            [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:loganalyzer.156',
                'Log Analyzer'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Review Server Logs</span>
          </a>

          <a
            tabindex="0"
            [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport_supportbundles.supportDashboard',
                'Support Bundles'
              )
            "
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Support Bundle</span>
          </a>

          <a
            tabindex="0"
            [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
            class="monitor-link"
            (click)="redirectToAUI('/audit-log', 'Audit Log')"
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Review Audit Logs</span>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="isAdvanceModeSwitchChecked === true" class="left-content advanced-options-content">
      <div class="advanced-options-content-title">Advanced Options</div>
      <div class="advanced-options-content-body">
        <div class="advanced-options-content-body-left-section">
          <div class="admin-section" data-section-type="agents">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-agents'"></mat-icon>
            </div>
            <div class="section-content">
             <div class="section-content-title">Agents</div>
             <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_agents_agenthost.agentHosts','Agent Managers')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage agents</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_agents_agent_status.agentStatus','Agent Status')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Check agent status</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_agents.agentPropertyNew','Agent Properties')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Global Properties</span>
              </a>
             <div class="download-agent-manager-section">
                <div class="download-agent-manager-section-title">
                  Download agent manager:
                </div>
                <div class="download-agent-manager-section-links-section">
                  <a tabindex="0" [class.disabled]="disableMenuItems()" class="download-agent-manager-link-styles" (click)="onItemSelect(items[0])">
                    <fc-svg-icon class="download-agent-manager-link-icon-styles" svgName="windows_icon"></fc-svg-icon>
                    <span class="download-agent-manager-link-label-styles">For Windows</span>
                  </a>
                  <a tabindex="0" [class.disabled]="disableMenuItems()" class="download-agent-manager-link-styles" (click)="onItemSelect(items[1])">
                    <fc-svg-icon class="download-agent-manager-link-icon-styles" svgName="linux_icon"></fc-svg-icon>
                    <span class="download-agent-manager-link-label-styles">For Linux</span>
                  </a>                  
                </div>
             </div>
            </div>            
          </div>
          <div class="admin-section" data-section-type="setup">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-setup'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Setup</div>
              <a tabindex="0" [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_cartridges_cartridgeinventory.cartridgeInventory','Cartridge Inventory')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Cartridges</span>
              </a>
              <a tabindex="0" [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport_managelicenses.manageLicensesLayout', 'Manage Licenses')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Administer Licenses</span>
              </a>
              <a tabindex="0" [class.disabled]="!isFoglightAdministrator" class="monitor-link" (click)="manageAlarmsAILicense()">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Foglight AI License</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_blackout_configuration.blackouts','Blackouts')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Blackouts</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport.82','Email Configuration')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Email Configuration</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport_proxy_configuration.proxyConfiguration','Proxy Configuration')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Proxy Configuration</span>
              </a>
            </div>
          </div>
          <div class="admin-section" data-section-type="investigate">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-investigate'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Investigate</div>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:corems.44','Retention Policies')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Retention Policies</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:corems.objectUsage','Object Cleanup')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Object Cleanup</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_data_manage_derived_metrics.manageDerivedMetrics','Derived Metrics')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Derived Metrics</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
                (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_data_manage20thresholds.manageThresholds','Manage Thresholds')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Thresholds</span>
              </a>
            </div>
          </div>
        </div>
        <div class="advanced-options-content-body-right-section">
        <div class="admin-section" data-section-type="mcp-servers">
          <div class="section-symbol">
            <mat-icon [svgIcon]="'fac-we-mcp-servers'"></mat-icon>
          </div>
          <div class="section-content">
            <div class="section-content-title">MCP Servers</div>
            <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link"
              (click)="downloadMcpInstaller()">
              <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
              <span>Download MCP Installer</span>
            </a>
            <a tabindex="0" class="monitor-link"
              href="https://docs.foglight.com/latest/integratingfoglight/mcpserver/" target="_blank" rel="noopener noreferrer">
              <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
              <span>Learn more</span>
            </a>
          </div>
        </div>
          <div class="admin-section" data-section-type="credentials">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-credentials'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Credentials</div>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_credentials.Credentials','Credentials')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Credentials</span>
              </a>              
            </div>
          </div>
          <div class="admin-section" data-section-type="diagnostic">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-diagnostic'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Diagnostic</div>
              <a tabindex="0" [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator" class="monitor-link"            (click)="              redirectTo(                'wcf?name=general-view-aui-wrapper&viewId=system:loganalyzer.156',                'Log Analyzer'              )            "          >
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Review Server Logs</span>
              </a>
              <a tabindex="0" [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator"
                class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport_supportbundles.supportDashboard','Support Bundles')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Support Bundle</span>
              </a>
              <a tabindex="0" [class.disabled]="isFoglightUserGroup || !isFoglightAdministrator" class="monitor-link"            (click)="redirectToAUI('/audit-log', 'Audit Log')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>            
                <span>Review Audit Logs</span>
              </a>
            </div>
          </div>

          <div class="admin-section" data-section-type="rules">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-rules'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Rules</div>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_rulesnotifications_rulemanagement.ruleManagement','Rules')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Rules</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_rulesnotifications_registryvariables.1','Manage Registry Variables')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Registry Variables</span>
              </a>
            </div>
          </div>
          <div class="admin-section" data-section-type="server">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-server'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Server</div>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport.16','Management Server Configuration')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Manage Server Configuration</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:performance.131','Performance')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Performance Overview</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_setupsupport.connectionStatus','Connection Status')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Connection Status</span>
              </a>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_tooling_script20editor.groovyScriptConsole','Script Console')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Script Console</span>
              </a>
            </div>
          </div>
          <div class="admin-section" data-section-type="downloads">
            <div class="section-symbol">
              <mat-icon [svgIcon]="'fac-we-downloads'"></mat-icon>
            </div>
            <div class="section-content">
              <div class="section-content-title">Downloads</div>
              <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" (click)="redirectTo('wcf?name=general-view-aui-wrapper&viewId=system:administration_cartridges_componentsfordownload.ComponentsForDownload','Components for Download')">
                <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
                <span>Explore Downloads</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="midLine">&nbsp;</div>
    <div class="mid-content">
      <span class="mid-title">Monitor your Databases and Servers</span>

      <div class="monitor-content">
        <div
          class="monitor"
          *ngIf="
            (isCloudEnv$ | async) ||
            (!(isCloudEnv$ | async) && isDbcartridgeInstalled)
          "
        >
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-database'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>
          <div class="monitor-title">Database</div>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectToMonitor('system:dbwc.16', 'Database', 'Database')
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor Database</span>
          </a>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            style="padding-top: 4px"
            (click)="
              redirectToMonitor(
                'foglight-sql-profiler/query-insights',
                'Database',
                'Query Insights',
                true
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Query Insights</span>
          </a>
          <a tabindex="0" [class.disabled]="disableMenuItems()" class="monitor-link" style="padding-top: 4px" (click)="redirectToMonitor('foglight-sql-profiler/query-explorer','Database','Query Explorer',true)">
            <mat-icon [svgIcon]="'fac-arrow-path'" class="mat-path-icon"></mat-icon>
            <span>Query Explorer</span>
          </a>
        </div>
        <div class="monitor">
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-host'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>

          <div class="monitor-title">Hosts</div>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:infrastructure.mainViewOfTheModule',
                'Infrastructure'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor Hosts</span>
          </a>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            style="padding-top: 4px"
            (click)="
              redirectToMonitor(
                'system:selector.66',
                'Infrastructure',
                'Environment Overview'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Environment Overview</span>
          </a>
        </div>
      </div>
      <div class="monitor-content">
        <div
          class="monitor"
          *ngIf="
            (isCloudEnv$ | async) ||
            (!(isCloudEnv$ | async) && isEvolveCartridgeInstalled)
          "
        >
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-vmware'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>
          <div class="monitor-title">VMware</div>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectToMonitor(
                'system:virtualvmw_monitoring.2',
                'Infrastructure',
                'VMware'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor VMware</span>
          </a>
        </div>
        <div
          class="monitor"
          *ngIf="
            (isCloudEnv$ | async) ||
            (!(isCloudEnv$ | async) && isEvolveCartridgeInstalled)
          "
        >
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-hyperv'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>
          <div class="monitor-title">HyperV</div>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectToMonitor(
                'system:HyperV_monitoring.4',
                'Infrastructure',
                'Hyper-V'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor HyperV</span>
          </a>
        </div>
      </div>
      <div class="monitor-content">
        <div
          class="monitor"
          *ngIf="
            (isCloudEnv$ | async) ||
            (!(isCloudEnv$ | async) && isEvolveCartridgeInstalled)
          "
        >
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-cloud-icon'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>
          <div class="monitor-title">Cloud</div>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectToMonitor(
                'system:cloud_manager.cloud',
                'Infrastructure',
                'Cloud'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor Cloud</span>
          </a>
        </div>
        <div
          class="monitor"
          *ngIf="
            (isCloudEnv$ | async) ||
            (!(isCloudEnv$ | async) && isEvolveCartridgeInstalled)
          "
        >
          <button tabindex="-1" monitor-btn [type]="'button'">
            <mat-icon
              [svgIcon]="'fac-kubernetes'"
              class="mat-monitor-icon"
            ></mat-icon>
          </button>
          <div class="monitor-title">Container</div>
          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              redirectToMonitor(
                'system:docker.dockerHomePage',
                'Infrastructure',
                'Container'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span> Monitor Container</span>
          </a>
        </div>
      </div>
    </div>
    <div class="midLine">&nbsp;</div>
    <div class="right-content">
      <span *ngIf="isCloudEnv$ | async" class="right-title"
        >Invite users and manage notifications</span
      >
      <span *ngIf="!(isCloudEnv$ | async)" class="right-title"
        >Manage Users and Notifications</span
      >

      <div class="user-content">
        <div class="user">
          <mat-icon
            [svgIcon]="'fac-we-usermanage'"
            class="mat-user-icon"
          ></mat-icon>
          <div class="monitor-title">User Management</div>

          <a
            tabindex="0"
            [class.disabled]="disableMenuItems()"
            class="monitor-link"
            (click)="
              isCloud
                ? redirectToAUI('/manage-users', 'Manage Users')
                : redirectTo(
                    'wcf?name=general-view-aui-wrapper&viewId=system:administration_userssecurity.main',
                    'Manage Users'
                  )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span *ngIf="isCloudEnv$ | async">Invite or manage user</span>
            <span *ngIf="!(isCloudEnv$ | async)">Manage Users & Security</span>
          </a>
        </div>

        <div class="user">
          <mat-icon
            [svgIcon]="'fac-we-notification'"
            class="mat-user-icon"
          ></mat-icon>
          <div class="monitor-title">Notification channels</div>

          <a
            tabindex="0"
            [class.disabled]="
              ((isCloudEnv$ | async) && isCloudUserGroup) ||
              (!(isCloudEnv$ | async) && isFoglightUserGroup)
            "
            class="monitor-link"
            (click)="setCurrentTab('contacts')"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Contacts</span>
          </a>
          <a
            tabindex="0"
            [class.disabled]="
              ((isCloudEnv$ | async) && isCloudUserGroup) ||
              (!(isCloudEnv$ | async) && isFoglightUserGroup)
            "
            class="monitor-link"
            (click)="setCurrentTab('notification-channels')"
            style="padding-top: 4px"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Notification Channels </span>
          </a>
        </div>
      </div>
      <div class="user-content">
        <div class="user">
          <mat-icon
            [svgIcon]="'fac-we-alarmtemplate'"
            class="mat-user-icon"
          ></mat-icon>
          <div class="monitor-title">Alarms Templates</div>

          <a
            tabindex="0"
            [class.disabled]="
              ((isCloudEnv$ | async) && isCloudUserGroup) ||
              (!(isCloudEnv$ | async) && isFoglightUserGroup)
            "
            class="monitor-link"
            (click)="redirectToAUI('/alarm-template', 'Alarm Template')"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Setup your own alarm template</span>
          </a>
        </div>

        <div class="user">
          <mat-icon [svgIcon]="'fac-we-alarm'" class="mat-user-icon"></mat-icon>
          <div class="monitor-title">Alarms</div>

          <a
            tabindex="0"
            [class.disabled]="
              ((isCloudEnv$ | async) && isCloudUserGroup) ||
              (!(isCloudEnv$ | async) && isFoglightUserGroup)
            "
            class="monitor-link"
            (click)="
              redirectTo(
                'wcf?name=general-view-aui-wrapper&viewId=system:core_alarms.alarmsMain',
                'Alarms'
              )
            "
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Review outstanding alarms </span>
          </a>
        </div>
      </div>

      <div class="user-content">
        <div class="user">
          <mat-icon
            [svgIcon]="'fac-integration-hub-icon-sm'"
            class="mat-user-icon"
          ></mat-icon>
          <div class="monitor-title">Integration HUB</div>

          <a
            tabindex="0"
            [class.disabled]="!isFoglightMonitoringAdministrator"
            class="monitor-link"
            (click)="redirectToAUI('/extended-integration/integration-hub', 'Integration HUB')"
          >
            <mat-icon
              [svgIcon]="'fac-arrow-path'"
              class="mat-path-icon"
            ></mat-icon>
            <span>Manage Integrations</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>